<div class="row mb-3">
  <div [ngClass]="{'col-lg': true, 'col-lg-12': !data.EqHubTekNo, 'col-lg-10': data.EqHubTekNo}">
    <table class="table table-heading-5 padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="max-w-140">{{ data?.MainObject }}</td>
        <td>{{ data?.ServiceDescription }}</td>
      </tr>
      <tr>
        <td class="max-w-140 fs-12">Doc.ref:</td>
        <td class="fs-12">{{ data?.DocumentReference }}</td>
      </tr>
      </tbody>
    </table>
  </div>

  @if (data.EqHubTekNo) {
    <div class="col-lg col-lg-2">
      <span class="float-lg-end me-2">
        <a [href]="data.EqHubTekNo" class="mt-0 float-lg-end doc-db-icon" target="_blank">
          <img src="./assets/images/icons/doc-db_icon.svg" alt="">
        </a>
      </span>
    </div>
  }
</div>

<!-- RCA-O Badge -->
<app-rca-tag
  [tagName]="data?.MainObject"
  [active]="data?.Ovr_Active"
  [inactive]="data?.Ovr_InActive"
  [inactiveCount]="data?.Ovr_InActive_Count"
  [type]="'RCA-O'"></app-rca-tag>
<!-- RCA-O Badge -->

<!-- TABS -->
<div class="form-group">
  <div class="row">
    <div class="col-lg-12">
      <div class="mt-3">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">

          <!-- CAUSE -->
          <li [ngbNavItem]="1">
            <a ngbNavLink>Causes</a>
            <ng-template ngbNavContent>
              <div class="p-4 border border-top-0">
                <!-- XS -->
                <p class="fs-12 mb-1">
                  <strong>XS</strong>
                </p>
                @if (data.xs.length) {
                  <table class="table table-bordered">
                    <thead>
                    <tr>
                      <th class="fs-12">Causes</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    @for (xs of data.xs; track xs) {
                      <tr>
                        <td class="fs-12">{{ xs.MainObject }}</td>
                        <td class="fs-12 text-center">{{ xs.DelaySeconds }}</td>
                        <td class="fs-12 text-center">
                          @if (xs.Conditional) {
                            <span
                              class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                              ngbTooltip="{{ xs.Conditional }}">Cond.</span>
                          }
                        </td>
                      </tr>
                    }
                    </tbody>
                  </table>
                } @else {
                  <div class="nz-spin-h">
                    <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="false"></nz-alert>
                  </div>
                }

                <!-- X -->
                <p class="fs-12 mb-1">
                  <strong>X</strong>
                </p>
                @if (data.x.length) {
                  <table class="table table-bordered mb-0">
                    <thead>
                    <tr>
                      <th class="fs-12">Causes</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    @for (x of data.x; track x) {
                      <tr>
                        <td class="fs-12">{{ x.MainObject }}</td>
                        <td class="fs-12 text-center">{{ x.DelaySeconds }}</td>
                        <td class="fs-12 text-center">
                          @if (x.Conditional) {
                            <span
                              class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                              ngbTooltip="{{ x.Conditional }}">Cond.</span>
                          }
                        </td>
                      </tr>
                    }
                    </tbody>
                  </table>
                } @else {
                  <div class="nz-spin-h">
                    <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="false"></nz-alert>
                  </div>
                }
              </div>
            </ng-template>
          </li>

          <!-- EFFECTS -->
          <li [ngbNavItem]="2">
            <a ngbNavLink>Effects</a>
            <ng-template ngbNavContent>
              <div class="p-4 border border-top-0">
                <!-- YX -->
                <p class="fs-12 mb-1">
                  <strong>YX</strong>
                </p>
                @if (data.yx.length) {
                  <table class="table table-bordered">
                    <thead>
                    <tr>
                      <th class="fs-12">Effects</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    @for (yx of data.yx; track yx) {
                      <tr>
                        <td class="fs-12">{{ yx.MainObject }}</td>
                        <td class="fs-12 text-center">{{ yx.DelaySeconds }}</td>
                        <td class="fs-12 text-center">
                          @if (yx.Conditional) {
                            <span
                              class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                              ngbTooltip="{{ yx.Conditional }}">Cond.</span>
                          }
                        </td>
                      </tr>
                    }
                    </tbody>
                  </table>
                } @else {
                  <div class="nz-spin-h">
                    <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="false"></nz-alert>
                  </div>
                }

                <!-- Y -->
                <p class="fs-12 mb-1">
                  <strong>Y</strong>
                </p>
                @if (data.y.length) {
                  <table class="table table-bordered mb-0">
                    <thead>
                    <tr>
                      <th class="fs-12">Effects</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    @for (y of data.y; track y) {
                      <tr>
                        <td class="fs-12">{{ y.MainObject }}</td>
                        <td class="fs-12 text-center">{{ y.DelaySeconds }}</td>
                        <td class="fs-12 text-center">
                          @if (y.Conditional) {
                            <span
                              class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                              ngbTooltip="{{ y.Conditional }}">Cond.</span>
                          }
                        </td>
                      </tr>
                    }
                    </tbody>
                  </table>
                } @else {
                  <div class="nz-spin-h">
                    <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="false"></nz-alert>
                  </div>
                }
              </div>
            </ng-template>
          </li>

        </ul>
        <div [ngbNavOutlet]="nav" class="mt-0"></div>
      </div>
    </div>
  </div>
</div>
